// extracted by mini-css-extract-plugin
export default {"root":"MultiSelect_root__PtiET","label":"MultiSelect_label__7E2K2"};